import { ITiaParty } from './node/tia-rest/model/response/party.response.model';
import { calculateAge } from './date';
import { CustomerTypes } from './customerTypes';
import { SessionUser } from 'next-auth';
import { JWT } from 'next-auth/jwt';

export const azureProviders = {
  azureAd: {
    name: 'azure-ad',
  },
  azureAdExt: {
    name: 'azure-ad-ext',
  },
};

export const getCustomerSession = (customerData: ITiaParty): SessionUser => {
  return {
    id: customerData.id.toString(),
    age: calculateAge(customerData.birthDate),
    partyId: customerData.id,
    name: customerData.name,
    firstName: customerData.forename,
    customerType:
      customerData.type === 0
        ? CustomerTypes.COMMERCIAL
        : CustomerTypes.PRIVATE,
  };
};

export const getIsCustomerFound = (customerData: ITiaParty): boolean => {
  return (
    customerData &&
    customerData !== null &&
    typeof customerData === 'object' &&
    'id' in customerData
  );
};

export const getIsSessionAgent = (session: JWT) => {
  if (!!session?.user?.id && !!session?.agent?.agentSessionId) {
    return true;
  }
  return false;
};

export const getIsAgentLoggedAsCustomer = (session: JWT) => {
  if (
    session?.user?.customerType !== CustomerTypes.AGENT &&
    !!session?.agent?.agentSessionId
  ) {
    return true;
  }
  return false;
};
